import { useFormik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "reactstrap";
import * as Yup from "yup";
import { ForgotPasswordAPI } from "../../api/authAPIs";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  PreviewCard,
} from "../../components/Component";
import LogoDark from "../../images/logo-dark.png";
import Logo from "../../images/logo.png";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";

toast.configure();

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Email is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await ForgotPasswordAPI({ body: { email: values.email } })
        const result = response.data;
        toast.success(result.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        navigate('/auth-reset-password')

      } catch (error) {
        toast.error("An error occurred. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <Head title="Forgot-Password" />
      <Block className="nk-block-middle nk-auth-body wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
            <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
            <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
          </Link>
        </div>
        <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h5">Reset password</BlockTitle>
              <BlockDes>
                <p>
                  If you forgot your password, well, then we’ll email you instructions to reset your
                  password.
                </p>
              </BlockDes>
            </BlockContent>
          </BlockHead>
          <form onSubmit={formik.handleSubmit}>
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label" htmlFor="email">
                  Email
                </label>
              </div>
              <input
                type="text"
                className={`form-control form-control-lg ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                  }`}
                id="email"
                placeholder="Enter your email address"
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="invalid-feedback">{formik.errors.email}</div>
              ) : null}
            </div>
            <div className="form-group">
              <Button color="primary" size="lg" className="btn-block" type="submit" disabled={loading}>
                {loading ? <Spinner size="sm" color="light" /> : "Send Reset Link"}
              </Button>
            </div>
          </form>
          <div className="form-note-s2 text-center pt-4">
            <Link to={`${process.env.PUBLIC_URL}/auth-login`}>
              <strong>Return to login</strong>
            </Link>
          </div>
        </PreviewCard>
      </Block>
      <AuthFooter />
    </>
  );
};

export default ForgotPassword;
